import http from '../helpers/http-common';
import { ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO } from '../models/happy-code-api.model';
import { baseCreate } from './base/base-create.service';
import { baseDelete } from './base/base-delete.service';
import { baseFindById } from './base/base-find-id.service';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';
import { baseUpdate } from './base/base-update.service';

export const useSubCategoriaService = () => {
	const resourceURL = '/subcategoria-despesa';

	const createCustom = (dto: ISubCategoriaDTO) => http.post(`${resourceURL}/create-custom`, dto);
	const patchCustom = (id: number, dto: ISubCategoriaDTO) => http.patch(`${resourceURL}/patch-custom/${id}`, dto);

	return {
		...baseCreate<ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO>(resourceURL),
		...baseFindById<ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO>(resourceURL),
		...baseFind<ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO>(resourceURL),
		...baseFindList<ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO>(resourceURL),
		...baseDelete(resourceURL),
		...baseUpdate<ISubCategoria, ISubCategoriaDTO, ISubCategoriaFullDTO>(resourceURL),
		createCustom,
		patchCustom,
	};
};
